export var getOptionLabel = function getOptionLabel(option) {
  if (typeof option === 'string') {
    return option; // Value selected with enter, right from the input
  }

  if (option.inputValue !== undefined) {
    return option.inputValue; // Add "xxx" option created dynamically
  }

  return option.title; // Regular option
};
export default getOptionLabel;